module.exports = __webpack_public_path__ + "static/img/wuxian-2.91393927.png";